import { useCallback, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import { BrandsExplorer } from "@/components/BrandsExplorer";
import { AlertsHubBar, AlertsHubToggle } from "@/components/AlertsHub";
import { PageIntro } from "@/components/Reveal";
import { usePageTitle } from "@/lib/hooks";

export default function BrandsPage() {
  usePageTitle("All Brands");
  const [params] = useSearchParams();
  const category = params.get("category") || "";
  const q = params.get("q") || "";
  const [followMode, setFollowMode] = useState(params.get("follow") === "1");
  const [selected, setSelected] = useState(() => new Map());
  const [shown, setShown] = useState([]);

  const toggle = useCallback((b) => setSelected((m) => {
    const next = new Map(m);
    if (next.has(b.id)) next.delete(b.id); else next.set(b.id, b);
    return next;
  }), []);
  const selectAll = () => setSelected((m) => { const next = new Map(m); shown.forEach((b) => next.set(b.id, b)); return next; });
  const exit = () => { setFollowMode(false); setSelected(new Map()); };

  return (
    <>
      <PageIntro eyebrow="Directory" title={"EXPLORE\nALL BRANDS"} desc="Every electrical brand in PRICEHUB. Filter by category, jump alphabetically, or sort by recently added and most downloaded." />
      <section className="mx-auto max-w-7xl px-5 pb-40 md:px-8">
        <div className="mb-8 flex flex-col gap-4 rounded-[1.75rem] border border-ph-accent/25 bg-gradient-to-r from-ph-lime/10 via-ph-surface to-ph-violet/10 p-5 sm:flex-row sm:items-center sm:justify-between" data-testid="alerts-hub-panel">
          <div>
            <p className="font-display text-xl font-bold text-ph-ink">Brand Alerts Hub</p>
            <p className="mt-1 text-sm text-ph-muted">{followMode ? "Tap brands to select them, then enter your email below." : "Follow as many brands as you like with one email — we'll tell you when their price lists change."}</p>
          </div>
          <AlertsHubToggle active={followMode} onClick={() => (followMode ? exit() : setFollowMode(true))} />
        </div>
        <BrandsExplorer key={`${category}|${q}`} initialCategory={category} initialQuery={q}
          followMode={followMode} selected={selected} onToggle={toggle} onShownChange={setShown} />
      </section>
      <AnimatePresence>
        {followMode && <AlertsHubBar selectedBrands={[...selected.values()]} onClear={() => setSelected(new Map())} onSelectAll={selectAll} onDone={exit} />}
      </AnimatePresence>
    </>
  );
}
